<template>
    <div class="box">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>单位管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true"  class="user-search" style="text-align: left;padding-top: 20px">
            <el-form-item label="" prop="SearchKey">
                <el-input  placeholder="请输入关键词" v-model="model.SearchKey" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button  type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button  type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表 -->
        <el-table border default-expand-all :data="dataList" style="width: 100%"  @selection-change="selectChange" highlight-current-row
            :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column prop="Name" label="单位名称" sortable width="180">
            </el-table-column>
            <el-table-column prop="Code" label="单位编码" sortable width="180">
            </el-table-column>
            <el-table-column prop="ServerIP" label="服务器地址" sortable width="180">
            </el-table-column>
            <el-table-column prop="Account" label="数据库登录账户" sortable width="180">
            </el-table-column>
            <el-table-column prop="Pwd" label="数据库密码" sortable width="180">
            </el-table-column>
            <el-table-column prop="Level" label="单位类型" sortable width="180">
            </el-table-column>
            <el-table-column prop="Language" label="开通语言" sortable width="180">
            </el-table-column>
            <el-table-column prop="LimitNumber" label="人数限制" sortable width="180">
            </el-table-column>
            <el-table-column prop="Province" label="所属省" sortable width="180">
            </el-table-column>
            <el-table-column prop="City" label="所属市" sortable width="180">
            </el-table-column>
            <el-table-column prop="Area" label="所属区" sortable width="180">
            </el-table-column>
            <el-table-column prop="Logo" label="单位logo" sortable width="180">
                <template slot-scope="scope">
                    <div class="demo-image__preview" >
                        <el-image 
                            style="width:60px;height:auto;margin-right:8px"
                            :src="scope.row.Logo" 
                            :preview-src-list="scope.row.Logo | filterLogo">
                        </el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="Images" label="宣传图片" sortable width="180">
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image  v-for="(item,index) in scope.row.Images" :key="index"
                            style="width:60px;height:auto;margin-right:8px"
                            :src="item" 
                            :preview-src-list="scope.row.Images | filterImgs">
                        </el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="Latitude" label="经度" sortable width="180">
            </el-table-column>
            <el-table-column prop="Latitude" label="纬度" sortable width="180">
            </el-table-column>
            <el-table-column prop="IsOpenPoints" label="是否开启积分挖掘" sortable width="180">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.IsOpenPoints" disabled=""></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="FaceFirmID" label="是否开启人脸识别" sortable width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.FaceFirmID == 0">未开启</span>
                    <span v-else>{{scope.row.FaceFirmName}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="PushMode" label="消息推送方式" sortable width="180">
            </el-table-column>
            <el-table-column prop="CreateTime" label="创建时间" sortable width="180">
            </el-table-column>
            <el-table-column label="操作" min-width="300" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" type="warning" @click="handleFace(scope.row)">初始化人脸信息</el-button>
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
        </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: left;padding-top: 10px">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="model.Page"
                layout="total,prev, pager, next, jumper"
                :total="listCount"
                :page-size="model.Rows">
            </el-pagination>
        </el-row>
        <add v-if="isShowAdd" :dialogFormVisible="isShowAdd" @closeAddDialog="handleCloseAdd"></add>
        <edit v-if="isShowEdit" :dialogFormVisible="isShowEdit" @closeEditDialog="handleCloseEdit" :data="editData"></edit>
    </div>
</template>

<script>
    import {GetCompanyList,DeleteCompany,InitCompanyFaces} from '../../api/company'
    import add from './add'
    import edit from './edit'
    export default {
        components: {
            add,
            edit
        },
        data() {
            return {
                isShowAdd: false,
                isShowEdit: false,
                listCount: null,
                dataList: [],
                editData: [],
                model: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: ''
                },
            }
        },
        watch: {
            'model.SearchKey': {
                handler(newVal) {
                    if(newVal === '') {
                        this.model.SearchKey = '';
                        this.GetCompanyList();
                    }
                }
            }
        },
        filters: {
            filterLogo(logo) {
                if(logo) {
                    return logo.split()
                }
            },
            filterImgs(images) {
                if(typeof(images)==='string') {
                    if(images.indexOf(';')!=-1) {
                        return images.split(';');
                    }else{
                        return images.split(' ');
                    }  
                }else{
                    return images;
                }
            },
        },
        mounted() {
            this.GetCompanyList();
        },
        methods: {
            GetCompanyList() {
                this.dataList = [];
                let Images;
                let Language;
                GetCompanyList(this.model).then(data=>{
                    if(!data.iserror) {
                        if(data.data.List.length > 0) {
                            data.data.List.forEach(element => {
                                if(element.Images) {
                                    if(element.Images.indexOf(';')!=-1) {
                                        Images = element.Images.split(';');
                                    }else{
                                        Images = element.Images.split(' ');
                                    }  
                                    element.Images =  Images;
                                }
                            });
                        }
                        this.dataList = data.data.List;
                        this.listCount = data.data.Count;
                    }
                })
            },
            handleCurrentChange(val) {
                this.model.Page = val;
                this.GetCompanyList();
            },
            selectChange(val) {
                this.selectdata = val
            },
            handleSearch() {
                if(this.model.SearchKey === '') {
                    this.$message({
                        message: '搜索内容不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                this.model.Page = 1;
                this.GetCompanyList();
            },
            handleAdd() {
                this.isShowAdd = true;
            },
            handleEdit(row) {
                this.editData = row;
                this.isShowEdit = true;
            },
            handleFace(row) {
                //初始化人脸信息
                this.$confirm('确认要初始化人脸信息吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    InitCompanyFaces({Code: row.Code}).then(data=>{
                        if(!data.iserror) {
                            this.$message({
                                message: '初始化人脸信息成功',
                                type: 'success'
                            });
                        }
                    })
                })
            },
            handleCloseAdd() {
                this.isShowAdd = false;
                this.GetCompanyList();
            },
            handleCloseEdit() {
                this.isShowEdit = false;
                this.GetCompanyList();
            },
            handleDelete(row) {
                let id = row.OID;
                this.$confirm('确认要删除该单位吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.DeleteCompany(id);
                })
            },
            DeleteCompany(id) {
                DeleteCompany({OID: id}).then(data=>{
                    if(!data.iserror) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.GetCompanyList();
                    }
                })
            }
        }
    }
</script>

<style>
.el-icon-circle-close:before {
    color: #ffffff;
}
</style>